export interface CoordinateAddress {
  latitude?: number | null;
  longitude?: number | null;
}

export interface CoordinateBranch {
  address?: CoordinateAddress | null;
}

export function getCoords(
  address?: CoordinateAddress | null,
  branch?: CoordinateBranch | null,
): [number, number] | null {
  if (address?.latitude != null && address?.longitude != null) {
    return [address.longitude, address.latitude];
  }

  if (branch?.address?.latitude != null && branch?.address?.longitude != null) {
    return [branch.address.longitude, branch.address.latitude];
  }

  return null;
}
